import client from './client';
import { unwrapData } from './response';

export const listDirectCharges = async (params = {}) => {
  const response = await client.get('/direct-charges/admin', { params });
  return unwrapData(response);
};

export const getDirectCharge = async (id) => {
  const response = await client.get(`/direct-charges/admin/${id}`);
  return unwrapData(response, null);
};

export const createDirectCharge = async (payload) => {
  const response = await client.post('/direct-charges/admin', payload);
  return unwrapData(response, null);
};

export const cancelDirectCharge = async (id) => {
  const response = await client.patch(`/direct-charges/admin/${id}/cancel`);
  return unwrapData(response, null);
};
